import { IEntity } from '../interfaces/models';
import { ID } from '@datorama/akita';
import { Column, Entity } from '../entity';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';

export interface IRole extends IEntity {
  roleName: string;
  active: boolean;
  description: string;
  entitlement: IEntitlement[];
}

export interface IEntitlement extends IEntity {
  userRoleId: string;
  privilegeId: ID;
}

@Entity({
  name: PageTitles.role,
  language: LanguagePage.roleUser,
})
export class Role implements IRole {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
    form: {
      defaultPosition: 1,
    },
  })
  roleName: string;

  @Column({
    type: ColumnType.string,
    isEditable: true,
    table: {
      defaultPosition: 2,
    },
    form: {
      defaultPosition: 2,
    },
  })
  description: string;

  @Column({
    type: ColumnType.boolean,
    isEditable: true,
    table: {
      defaultPosition: 3,
    },
    form: {
      defaultPosition: 3,
    },
  })
  active: boolean;

  id: ID;
  createdAt: Date;
  modifiedAt: Date;
  createdBy: string;
  modifiedBy: string;
  href: string;
  entitlement: any[];

  constructor(
    role: IRole = {
      id: '',
      createdAt: new Date(),
      modifiedAt: new Date(),
      createdBy: '',
      modifiedBy: '',
      roleName: '',
      active: false,
      href: null,
      description: '',
      entitlement: [],
    }
  ) {
    const {
      id,
      createdAt,
      modifiedAt,
      createdBy,
      modifiedBy,
      roleName,
      active,
      href,
      description,
      entitlement,
    } = role;

    this.id = id;
    this.roleName = roleName;
    this.description = description;
    this.active = active;
    this.createdAt = createdAt;
    this.modifiedAt = modifiedAt;
    this.createdBy = createdBy;
    this.modifiedBy = modifiedBy;
    this.href = href;
    this.entitlement = entitlement;
  }
}
